import PropTypes from "prop-types"

import { useNavigate, useParams } from "react-router-dom"
import ContainerWithSideBar from "./ContainerWithSideBar"
import SearchInput from "./SearchInput"
import Header from "./Header"
import FaqLink from "./FaqLink"
import { BlocksRenderer } from "@strapi/blocks-react-renderer"
import { getFaqBySlug } from "../../lib/cmsFaqs"

function Answer({ isMobile }) {
  const navigate = useNavigate()
  const { faqSlug } = useParams()

  const { faq, section } = getFaqBySlug(faqSlug)

  if (!faq) {
    navigate("/help")
  }

  return (
    <div>
      <Header>
        <FaqLink size="h3" section={section} suffix=" FAQs" />
      </Header>
      <SearchInput />
      <ContainerWithSideBar isMobile={isMobile}>
        <div style={{ flex: 1 }}>
          <h1>{faq.data.question}</h1>
          <BlocksRenderer content={faq.data.answer} />
        </div>
      </ContainerWithSideBar>
    </div>
  )
}

Answer.propTypes = {
  isMobile: PropTypes.bool,
}

export default Answer
